module.exports = __webpack_public_path__ + "static/media/gobiMove.f49c091e.mp3";